import { render, staticRenderFns } from "./UserChangeEmailForm.vue?vue&type=template&id=e158b6f2"
import script from "./UserChangeEmailForm.vue?vue&type=script&lang=js"
export * from "./UserChangeEmailForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports